import { Badge, type BadgeProps } from '@mantine/core';
import { statusPalette, type StatusVariant } from '../../theme/colors';

const labels: Record<StatusVariant, string> = {
  entwurf: 'Entwurf',
  inBearbeitung: 'In Bearbeitung',
  eingereicht: 'Eingereicht',
  revision: 'Revision',
  inPruefung: 'In Prüfung',
  abgelehnt: 'Abgelehnt',
  freigegeben: 'Freigegeben',
  aktiv: 'Aktiv',
  inaktiv: 'Inaktiv',
  ok: 'OK',
  warnung: 'Warnung',
  fehler: 'Fehler',
};

interface StatusBadgeProps extends Omit<BadgeProps, 'color' | 'variant'> {
  status: StatusVariant;
  /**
   * Überschreibt die Standardbeschriftung der Variante. Für Fälle, in denen die Farbwelt einer
   * Variante passt, die Domäne den Zustand aber anders benennt — z. B. die Unfallauswertung, die
   * ein Werk ohne Meldung als „Ausstehend" in der fehler-Farbwelt zeigt.
   */
  label?: string;
}

export function StatusBadge({ status, label, ...rest }: StatusBadgeProps) {
  const { bg, border, fg } = statusPalette[status];
  return (
    <Badge
      radius="lg"
      styles={{
        root: {
          backgroundColor: bg,
          border: `1px solid ${border}`,
          color: fg,
          fontWeight: 700,
          textTransform: 'none',
          minHeight: 24,
        },
      }}
      {...rest}
    >
      {label ?? labels[status]}
    </Badge>
  );
}
